<template>
  <el-card>
    <template #header>
      <h4>{{ $t('交易中心') }}</h4>
    </template>

    <el-row v-for="(l1, index) in rowData" :key="index">
      <el-col v-for="(item, lIndex) in l1" :key="lIndex" :span="5">
        <div class="item">
          <span>{{ $t(item.name) }}</span>
          <span class="count">{{ data[item.key] | filterPrice }}</span>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: "DealStat",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rowData: [
        [
          { name: '今日菜谱付费金额', count: 0, key: "todayPayCbPrice" },
          { name: '今日菜谱打赏金额', count: 0, key: "todayRewardCbPrice" },
          { name: '今日合计总金额', count: 0, key: "todaySumAllPrice" },
          { name: '今日平台储值额', count: 0, key: "todayInPrice" },
        ],
        [
          { name: '菜谱付费总金额', count: 0, key: "totalPayCbPrice" },
          { name: '菜谱打赏总金额', count: 0, key: "totalRewardCbPrice" },
          { name: '总计合计总金额', count: 0, key: "totalSumAllPrice" },
          { name: '平台储值金额', count: 0, key: "totalInPrice" },
        ],
      ]
    }
  },
  filters: {
    filterPrice(price) {
      if(!price) return 0;
      return price.toFixed(2);
    }
  }
}
</script>

<style scoped>

.el-row {
  margin-bottom: 50px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
}

.count {
  font-weight: 600;
  font-size: 20px;
}

</style>
